module.exports = __webpack_public_path__ + "media/images/illustrations/mover_with_sixteen_foot_truck_small-f3f18937d0147465fc60abc9b3a0bc5b.svg";